<template>
    <div class="checkbox-group" :class="display">
        <label
            class="checkbox"
            v-for="(c, i) in items"
            :key="name + '-' + i"
            :class="labeldisplay( i, c.value )">
            <div class="check-block">
                <input
                    type="checkbox"
                    :disabled="disabled"
                    :name="name"
                    :value="c.value"
                    v-model="selected"
                    @ref="c.value"
                    @change="update">
            </div>
            {{c.label}}
        </label>
    </div>
</template>

<script>
    import { THEMES, SIZES } from '@/data/themes'

    export default {
        name: "OSJCheckboxGroup",
        data(){
            return {
                selected : []
            }
        },
        model : {
            prop : "checked"
        },
        watch : {
            checked : {
                immediate : true,
                handler ( val ){
                    this.selected = val
                }
            }
        },
        props : {
            columns  : Number,
            limit    : Number,
            disabled : Boolean,
            items    : {
                type : Array,
                required : true
            },  
            name     : {
                type : String,
                required : true
            },
            checked : Array,
            theme : String,
            size : String
        },
        methods : {
            update(){
                while( this.reachedLimit( this.selected.length ) ){
                    this.selected.shift()
                }
                this.$emit( "input", this.selected )
            },
            reachedLimit( count ){
                return this.limit && count > this.limit
            },
            labeldisplay( i, v ){
                return [
                    this.checked.indexOf( v ) > -1 ? 'selected' : "",
                    THEMES[this.theme] || THEMES.light,
                    SIZES[this.size] || SIZES.small
                ]
            }
        },
        computed : {
            display(){
                return [ this.columns ? 'col-' + this.columns : undefined ]
            }
        }
    }
</script>

<style lang="scss">
    @import "../scss/vars";

    .checkbox-group{
        display: flex;
        flex-wrap: wrap;
        flex-direction: row;
        margin-bottom: 1rem;

        &.col-2 .checkbox{
            flex-basis: 45%;
        }
        &.col-3 .checkbox{
            flex-basis: 30%;
        }
        &.col-4 .checkbox{
            flex-basis: 22%;
        }
        .checkbox{
            flex-basis: 90%;
        }
    }

    .check-block{
        width: 2rem;
        height: 2rem;
        background: white;
        border: 1px solid $pale-gray;
        border-radius: 4px;
        position: relative;
        margin-right: 1rem;

        .checked &{
            background: $dark-green;
            border: 1px solid $dark-green;
        }

        input{
            position: absolute;
            opacity: 0;
            cursor: pointer;
            height: 0;
            width: 0;
        }
    }
    
    .checkbox{
        display: flex;
        margin-bottom: 1rem;
        cursor: pointer;
    }

    .theme{
        &-dark{
            color: $gray;

            &.selected{
                .check-block{
                    border: 1px solid $dark-green;
                    background-color: $dark-green;
                }
            }

            .check-block{
                background-color: white;
                border: 1px solid $mid-gray; 
            }
        }
        &-light{
            color: $pale-gray;
            
            &.selected{
                .check-block{
                    border: 1px solid $dark-green;
                    background-color: $dark-green;
                }
            }

            .check-block{
                background-color: #ccc;
                border: 1px solid #ccc; 
            }
        }
    }

    .size{
        &-small{
            .box{
                width: 1.6rem;
                height: 1.6rem;
            }
        }
        &-large{
            font-size: 1.8rem;
            .box{
                width: 2rem;
                height: 2rem;
            }
        }
    }
</style>